import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormService } from '@services/base-form.service';
import { ListarPedidosService } from '@services/listar-pedidos.service';
import { NoDataAvailableComponent } from '../../../components/no-data-available/no-data-available.component';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CpfPipe } from '../../../pipes/cpf.pipe';

@Component({
    selector: 'app-recarga-certa',
    templateUrl: './recarga-certa.component.html',
    styleUrls: ['./recarga-certa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoDataAvailableComponent, SelectComponent, NgxPaginationModule, CpfPipe]
})
export class RecargaCertaComponent extends BaseFormService implements OnInit  {

  public itemsPerPage = 5;
  public resources : any = [];
  public currentPage = 1;
  public totalItems = 0;

  @Input() idPedido: any;

  constructor( private readonly service: ListarPedidosService ) {  super();}

  ngOnInit(): void {
    this.getAllCnpjs();
  }

  public getAllCnpjs() {

    this.service.getAlldados(this.idPedido)
    .subscribe({
      next: (success: any) => {
        this.resources = success.response;
        this.totalItems = this.resources?.dados?.length ?? 0;
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  getPage(page: number) {
    this.currentPage = page;
  }
}
